<template>
  <div class='base-footer'>
      <div>
          <span>
            <img src="../../assets/images/logo.png" alt="">
            <span>
                地址：北京市丰台区南四环西路188号三区6号楼
                <el-divider direction="vertical"></el-divider>
                电话：01057986000
                <el-divider direction="vertical"></el-divider>
                邮编：100070 
            </span>
        </span>
        <span>中国卒中学会版权所有</span>
        <a href="https://beian.miit.gov.cn/" target="blank">京ICP备10002972号-39</a>
      </div>
  </div>
</template>

<script>
export default {
    name: 'BaseFooter'
}
</script>

<style lang='less'>
    .base-footer {
        width: 100%;
        height: 95px;
        background: rgb(246, 247, 247);
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 1;
        font-size: 13px;
        color: #575757;
        & > div {
            width: 933px;
            margin: 0 auto;
            padding-top: 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
                width: 50px;
                height: 50px;
                margin-right: 35px;
            }
            span:first-child {
                display: flex;
                align-items: center;
            }
        }
    }
</style>
